import type { Mission } from '../missions.ts'

export const cbpAmo: Mission = {
  id: "cbp-amo",
  name: "Air and Marine Operations",
  short: "AMO",
  call: "Air and Marine",
  kind: "subagency",
  parent: "cbp",
  url: "https://www.cbp.gov/border-security/air-sea",
  palette: {
    primary: "#78503c",
    secondary: "#48392b",
    accent: "#b19b7a",
  },
  colorSource: {
    kind: "seal",
    url: "https://commons.wikimedia.org/wiki/File:CBP_Air_and_Marine_Operations_Emblem.png",
  },
  motif: "plane",
  mission: {
    text: "AMO’s mission is to safeguard our nation by anticipating and confronting security threats through our aviation and maritime law enforcement expertise, innovative capabilities, and partnerships at the border and beyond.",
    url: "https://www.cbp.gov/about/leadership-organization/executive-assistant-commissioners-offices/air-and-marine-operations",
  },
  fact: {
    text: "AMO operates approximately 240 aircraft and 300 marine vessels throughout the United States, Puerto Rico and the U.S. Virgin Islands.",
    url: "https://www.cbp.gov/about/leadership-organization/executive-assistant-commissioners-offices/air-and-marine-operations",
  },
  seal: {
    file: "public/seals/cbp-amo.png",
    source: "https://commons.wikimedia.org/wiki/File:CBP_Air_and_Marine_Operations_Emblem.png",
  },
  identifier: {
    about: "https://www.cbp.gov/about",
    accessibility: "https://www.cbp.gov/site-policy-notices/accessibility",
    foia: "https://www.cbp.gov/site-policy-notices/foia",
    noFear: "https://www.cbp.gov/about/eeo/no-fear-act",
    oig: "https://www.oig.dhs.gov/",
    performance: "https://www.cbp.gov/document/publications/cbp-strategy-2021-2026",
    privacy: "https://www.cbp.gov/site-policy-notices/privacy-policy",
  },
  media: {
    photos: [
      {
        file: "/media/cbp-amo-coastal-interceptor.jpg",
        small: "/media/cbp-amo-coastal-interceptor-sm.jpg",
        alt: "A gray CBP Coastal Interceptor Vessel with four outboard engines speeds across open water, throwing a long white wake.",
        title: "AMO Coastal Interceptor Vessel under way, September 13, 2016",
        creator: "U.S. Customs and Border Protection",
        source: "https://commons.wikimedia.org/wiki/File:AMO_deploys_new_Coastal_Interceptor_Vessel_(29048260284).jpg",
        license: "Public domain (U.S. government work)",
      },
      {
        file: "/media/cbp-amo-big-bend-helicopter.jpg",
        small: "/media/cbp-amo-big-bend-helicopter-sm.jpg",
        alt: "A dark blue and gold AMO UH-1N helicopter hovers low over rocky desert terrain under a clear blue sky in Big Bend National Park.",
        title: "AMO Alpine Air Unit UH-1N helicopter in Big Bend National Park, December 6, 2019",
        creator: "CBP Photography, U.S. Customs and Border Protection",
        source: "https://commons.wikimedia.org/wiki/File:Alpine_Air_unit_helicopter_operations_in_Big_Bend_Sector_(49213694256).jpg",
        license: "Public domain (U.S. government work)",
      },
    ],
  },
}
